﻿import React from 'react';
//import * as Ids from './Ids';
import ReactModal from 'react-modal';
import { connect } from 'react-redux';
import VilkarComponent from './Components/VilkarComponent';
import { EpiContext } from '../Shared/Scripts/Store/EpiContext/Types';
import { FeilmeldingComponent } from '../Shared/Scripts/Components/FeilmeldingComponent';
import { VeilederFarBarnAppState } from './Store';
import contentResolver from '../Shared/Scripts/Utilities/EpiContentResolver';
import { AppModalHvorLengeContainerId } from './Ids';
import { AppModalOmStudieplassContainerId } from './Ids';
import { AppModalOmPermisjonContainerId } from './Ids';
import { AppModalOmNavContainerId } from './Ids';
import { AppModalErStudentContainerId } from './Ids';
import { AppModalOmNarJegKanSokeContainerId } from './Ids';
import VeilederFarBarnDto from './Models/VeilederFarBarnDto';

interface AppOwnProps {
    modalid: string;
}

type AppProps = MapStateToProps & AppOwnProps;

ReactModal.setAppElement(document.getElementById(AppModalOmNavContainerId) as HTMLElement);

export class App extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }
    render(): JSX.Element {
        const { epiContext } = this.props;
        const { epiModel } = this.props.epiContext;
        if (epiContext.epiModelFeilet) {
            return <FeilmeldingComponent />;
        }
        if (epiModel != null) {
            if (this.props.modalid === AppModalHvorLengeContainerId) {
                return (
                    <VilkarComponent
                        lenketekst={contentResolver(epiContext, 'lenketekstOmHvorLenge')}
                        tittel={contentResolver(epiContext, 'modalTittelOmHvorLenge', 2)}
                        innhold={contentResolver(epiContext, 'modalContentOmHvorLenge', 2)}
                        lukk={contentResolver(epiContext, 'ariaLabelTilLenkeOmHvorLenge', 2)}
                    />
                );
            }
            if (this.props.modalid === AppModalOmStudieplassContainerId) {
                return (
                    <VilkarComponent
                        lenketekst={contentResolver(epiContext, 'lenketekstOmStudieplass')}
                        tittel={contentResolver(epiContext, 'modalTittelOmStudieplass', 2)}
                        innhold={contentResolver(epiContext, 'modalContentOmStudieplass', 2)}
                        lukk={contentResolver(epiContext, 'ariaLabelTilLenkeOmStudieplass', 2)}
                    />
                );
            }
            if (this.props.modalid === AppModalOmPermisjonContainerId) {
                return (
                    <VilkarComponent
                        lenketekst={contentResolver(epiContext, 'lenketekstOmPermisjon')}
                        tittel={contentResolver(epiContext, 'modalTittelOmPermisjon', 2)}
                        innhold={contentResolver(epiContext, 'modalContentOmPermisjon', 2)}
                        lukk={contentResolver(epiContext, 'ariaLabelTilLenkeOmPermisjon', 2)}
                    />
                );
            }
            if (this.props.modalid === AppModalOmNavContainerId) {
                return (
                    <VilkarComponent
                        lenketekst={contentResolver(epiContext, 'lenketekstOmNav')}
                        tittel={contentResolver(epiContext, 'modalTittelOmPengerFraNav', 2)}
                        innhold={contentResolver(epiContext, 'modalContentOmvPengerFraNav', 2)}
                        lukk={contentResolver(epiContext, 'ariaLabelTilLenkeOmPengerFraNav', 2)}
                    />
                );
            }
            if (this.props.modalid === AppModalErStudentContainerId) {
                return (
                    <VilkarComponent
                        lenketekst={contentResolver(epiContext, 'lenketekstOmBeggeErStudent')}
                        tittel={contentResolver(epiContext, 'modalTittelOmBeggeErStudent', 2)}
                        innhold={contentResolver(epiContext, 'modalContentOmBeggeErStudent', 2)}
                        lukk={contentResolver(epiContext, 'ariaLabelTilLenkeOmBeggeErStudent', 2)}
                    />
                );
            }
            if (this.props.modalid === AppModalOmNarJegKanSokeContainerId) {
                return (
                    <VilkarComponent
                        lenketekst={contentResolver(epiContext, 'lenketekstOmNarJegKanSoke')}
                        tittel={contentResolver(epiContext, 'modalTittelOmNarJegKanSoke', 2)}
                        innhold={contentResolver(epiContext, 'modalContentOmNarJegKanSoke', 2)}
                        lukk={contentResolver(epiContext, 'ariaLabelTilLenkeOmNarJegKanSoke', 2)}
                    />
                );
            }
        }
        return <div>Laster...</div>;
    }
}
interface MapStateToProps {
    epiContext: EpiContext<VeilederFarBarnDto>;
}
const mapStateToProps = (state: VeilederFarBarnAppState): MapStateToProps => ({
    epiContext: state.epiContext,
});

export default connect(mapStateToProps)(App);
